<template>
  <div id="addContainer" v-loading="loading" :element-loading-text="loadingTxt"
    element-loading-background="rgba(255,255,255,0.7)">
    <div class="formWarp" :class="{ 'formWarp--add': showType === 'add' }">
      <div v-if="showType === 'check'" class="progressIng">
        <div style="display: flex; align-items: center">
          <div class="taskName">
            {{ taskData.taskName }}
          </div>
          <el-tag style="margin-left: 5px; border-radius: 17px" :type="taskData.taskStatus == 0
            ? 'info'
            : taskData.taskStatus == 1
              ? 'success'
              : taskData.taskStatus == 2
                ? ''
                : 'danger'
            ">
            {{ taskData.taskStatusName }}
          </el-tag>
        </div>
        <div>
          <span class="createDate">创建时间：{{ taskData.createDate }}</span>
          <el-button type="primary" size="small" @click="openProgressFeedBackBox">
            进度反馈
          </el-button>
        </div>
      </div>
      <!-- 基本信息 -->
      <div class="baseInfo">
        <!-- 详情 -->
        <h4 v-if="checkType == 'check'" class="header-title">
          任务详情
        </h4>
        <div class="contentInfo">
          <el-form v-if="checkType == 'check'" ref="baseForm8" :inline="true" :model="baseForm"
            class="demo-form-inline baseForm" label-position="left" size="small">
            <el-row :gutter="20">
              <el-col :span="7">
                <el-form-item label="创建人" label-width="120px">
                  <el-input v-model="taskData.createUserName" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="任务开始时间" label-width="120px">
                  <el-input v-model="baseForm.startDate" readonly value-format="yyyy-MM-dd" type="date">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="任务结束时间" label-width="120px">
                  <el-input v-model="baseForm.endDate" readonly value-format="yyyy-MM-dd" type="date">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="7">
                <el-form-item label="工期" label-width="120px">
                  <el-input v-model="schedule" readonly style="width: 50%">
                    <template slot="append">
                      天
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="7">
                <el-form-item label="任务类型" label-width="120px">
                  <el-input v-model="baseForm.taskType.cnName" readonly />
                </el-form-item> -->
              <!-- </el-col> -->
              <!-- <el-col :span="7">
                <el-form-item label="标准工期" label-width="120px">
                  <el-input v-model="baseForm.standardSchedule" style="width: 50%" placeholder="请输入标准工期" readonly>
                    <template slot="append">
                      天
                    </template>
                  </el-input>
                </el-form-item>
              </el-col> -->
            </el-row>

            <el-row :gutter="20">
              <el-col :span="7">
                <el-form-item label="专业" label-width="120px">
                  <el-input v-model="baseForm.spec" type="textarea" autosize :title="baseForm.specList" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="责任人" label-width="120px">
                  <el-input v-model="userInfo" type="textarea" autosize readonly />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="7">
                <el-form-item label="是否关键任务" label-width="120px">
                  <span> {{ baseForm.coreTask ? '是': '否' }}</span>
                </el-form-item>
              </el-col>
              <el-col v-if="enableBindToFlow" :span="7">
                <el-form-item label="关联流程" label-width="120px">
                  <el-input v-model="baseForm.flowDefinitionNames" readonly />
                </el-form-item>
              </el-col>
              <!-- <el-col  :span="7">
                <el-form-item label="工序编号" label-width="120px">
                  <el-input v-model="baseForm.operationCode" readonly />
                </el-form-item>
              </el-col> -->
              <!-- <el-col  :span="7">
                <el-form-item label="所属位置" label-width="120px">
                  <el-input v-model="baseForm.position" readonly />
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-form>
        </div>
        <!-- 添加和编辑 -->
        <h4 v-if="checkType != 'check'" class="header-title">
          基本信息
        </h4>
        <el-form v-if="checkType != 'check'" ref="baseForm" :inline="true" :model="baseForm" :rules="baseFormRules"
          class="demo-form-inline baseForm" label-position="top" size="small" :disabled="showType === 'check'">
          <el-row :gutter="60">
            <el-col :span="18">
              <el-form-item label="名称" prop="taskName">
                <el-input v-model="baseForm.taskName" maxlength="30" show-word-limit placeholder="请输入任务名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="6">
              <el-form-item label="任务开始时间" prop="startDate">
                <el-date-picker :key="startDateKey" ref="startDateRef" v-model="baseForm.startDate"
                  :picker-options="startDatePickerOptions" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="任务结束时间" prop="endDate">
                <el-date-picker :key="endDateKey" ref="endDateRef" v-model="baseForm.endDate"
                  :picker-options="endDatePickerOptions" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工期" prop="customer">
                <el-input v-model="schedule" disabled placeholder="选择时间"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="60">
            <!-- <el-col :span="6">
              <el-form-item label="任务类型" prop="customerManager">
                <el-tree-select v-model="baseForm.taskType" :options="taskTypeTreeData" :props="taskTypeTreeProps"
                  @change="taskTypeChange"
                />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item label="标准工期" prop="standardSchedule">
                <el-input v-model="baseForm.standardSchedule" placeholder="请输入标准工期" maxlength="5">
                  <template slot="append">
                    天
                  </template>
                </el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="专业" prop="specIds">
                <el-select v-model="baseForm.specIds" style="max-height: 150px; overflow: auto" filterable multiple
                  placeholder="请选择" value-key="id">
                  <el-option v-for="(item, index) in specList" :key="index" :label="item.cnName" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="责任人" prop="taskUserName">
                <el-input v-model="userInfo" readonly size="small">
                  <template slot='suffix'>
                    <i class='el-icon-circle-close' @click='clearUser'></i>
                  </template>
                  <template slot="append">
                    <el-button size="small" @click="managerBtn()"> 选择负责人</el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="关键任务" prop="coreTask">
                <el-select v-model="baseForm.coreTask" size="small">
                  <el-option v-for="(item, index) in coreTaskList" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="60">
            <el-col v-if="enableBindToFlow" :span="6">
              <el-form-item label="关联流程" prop="flowDefinitionIdList">
                <el-cascader v-model="baseForm.flowDefinitionIdList" :options="processList" :props="processOptions"
                  :show-all-levels="false" filterable style="width:100%" clearable>
                </el-cascader>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="工序编号" prop="operationCode">
                <el-input v-model="baseForm.operationCode" maxlength="10" show-word-limit placeholder="请输入工序编号" oninput="value=value.replace(/[^\d]/g,'')" :min="1"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="位置/选择集" prop="position" v-if="placeType == 1">
                <el-select v-model="baseForm.position" style="max-height: 150px; overflow: auto" filterable
                  placeholder="请选择位置/选择集">
                  <el-option v-for="(item, index) in selectSetData" :key="index" :label="item.folderName"
                    :value="item.folderName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 暂时不知道 -->
          <el-row v-if="showType === 'check'" :gutter="60">
            <el-col :span="6">
              <el-form-item label="创建人2">
                <el-input v-model="taskData.createUserName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
            </el-col>
            <el-col :span="6"></el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 任务指引 -->
      <el-card shadow="never" :class="!taskGuideTrans && 'closed'">
        <div slot="header" @click="() => taskGuideTrans = !taskGuideTrans"
          style="cursor: pointer; display: flex; gap: 20px; align-items: center;">
          <span style="font-weight: bold">任务指引</span>
          <span style="margin-left: auto;"></span>
          <!-- 编辑 时候的保存任务指引 按钮 -->
          <el-button size="mini" type="primary" plain v-if="showType !== 'check' && isGuideEditShow" title="保存"
            style="cursor: pointer" @click.stop="submitTaskGuideForm('edit')">确认修改</el-button>
          <!-- 添加 时候的保存任务指引 按钮-->
          <el-button size="mini" type="primary" plain v-if="showType !== 'check' && !isGuideEditShow"
            style="cursor: pointer" @click.stop="submitTaskGuideForm('add')">保存</el-button>
          <i :class="taskGuideTrans ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="font-weight: bold;"></i>
        </div>
        <el-collapse-transiton>
          <div v-show="taskGuideTrans">
            <!-- 添加和编辑时才有 -->
            <el-form v-if="showType !== 'check'" ref="taskGuideForm" :model="taskGuideForm" :rules="taskGuideRules"
              label-width="100px" class="demo-ruleForm" label-position="left"
              style=" height: 90%; overflow: auto; position: sticky; top: 0; background-color: #fff; ">
              <el-row>
                <el-col>
                  <el-form-item label="任务指引" prop="guide">
                    <el-input v-model="taskGuideForm.guide" maxlength="500" show-word-limit type="textarea" :rows="4"
                      placeholder="请输入任务指引">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="上传附件">
                    <el-upload :action="action" :limit="5" :on-success="taskFileOnSuccess" :on-remove="taskFileOnRemove"
                      :headers="headers" :file-list="taskGuideForm.fileKeys" style="width: 100%" class="addupload">
                      <el-button size="small" type="primary" plain icon="el-icon-upload2">
                        上传文件
                      </el-button>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <!-- 任务指引列表 -->
            <el-collapse v-if="guideList && guideList.length > 0" v-model="guideActive" accordion
              @change="guideSelectChange">
              <el-collapse-item v-for="(item, index) in guideList" :key="index" :name="index">
                <template slot="title">
                  <el-input v-model="item.guide" type="textarea" readonly autosize resize='none'/>
                  <i v-if="showType !== 'check'" class="header-icon el-icon-close" @click.stop="removeGuide(index)" title='移除'></i>
                  <i v-if="showType !== 'check' && index !== 0" class="header-icon el-icon-top"
                    @click.stop="up(index)" title="上移"></i>
                  <i v-if="showType !== 'check' && index !== guideList.length - 1" class="header-icon el-icon-bottom"
                    @click.stop="down(index)" title='下移'></i>
                </template>
                <el-table v-if="item.fileKeys.length > 0" :data="item.fileKeys" @row-click="dataPreview">
                  <el-table-column label="名称" prop="realName">
                  </el-table-column>
                </el-table>
                <!-- <el-upload disabled :file-list="item.fileKeys" :on-preview="dataPreview" :action="action">
              </el-upload> -->
              </el-collapse-item>
            </el-collapse>

          </div>
        </el-collapse-transiton>
      </el-card>
      <!-- 进度 编辑的时候才有 -->
      <div v-show="showType === 'check'" class="progressStatus"
        style="margin-bottom: 15px; display: flex; align-items: center">
        <span>进度：</span>
        <el-progress :text-inside="true" :stroke-width="20" :percentage="taskData.taskProgress" style="flex: 2">
        </el-progress>
      </div>
      <!-- 紧前任务 添加和编辑的时候才有-->
      <div class="frontTask">
        <div class="task-header" @click="() => preTaskTrans = !preTaskTrans">
          <h4 style="margin: 0; font-weight: bold; margin-right:10px">
            紧前任务
          </h4>
          <el-button v-if="checkType != 'check'" size="small" type="mini" plain :disabled="showType === 'check'"
            @click.stop="openPreTaskBox">
            <i class="el-icon-plus"></i>添加
          </el-button>
          <i :class="preTaskTrans ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            style="font-weight: bold;margin-left:auto;"></i>
        </div>

        <el-collapse-transiton>
          <div v-show="preTaskTrans">
            <el-form ref="preTaskForm" :inline="true" :model="preTaskForm" :rules="preTaskFormRules"
              class="demo-form-inline baseForm" label-position="top" :disabled="showType === 'check'">
              <el-row v-show="preTaskForm.preTaskList.filter(
                (item) => item.relaStatus === '1'
              )[0]
                " style="margin-bottom: 15px" :gutter="60">
                <el-col :span="18">
                  <div>
                    开始-开始：以下任务开始后，当前任务才能开始
                  </div>
                  <div class="content" style="max-height: 200px; overflow-y: auto">
                    <div v-for="(item, index) in preTaskForm.preTaskList.filter(
                      (item) => item.relaStatus === '1'
                    )" :key="index" class="item"
                      style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; ">
                      <span style="color: #8daeed">
                        <span style="margin-right: 10px">{{
                          getWBSCode(item, 1)
                        }}</span>
                        {{ item.preTaskName || item.taskName }}</span>
                      <span>
                        <i v-if="showType !== 'check'" class="el-icon-close" style="color: red; cursor: pointer"
                          @click="delPreTask(item, index)"></i>
                      </span>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <el-row v-show="preTaskForm.preTaskList.filter((item) => item.relaStatus === '0')[0]" :gutter="60">
                <el-col :span="18">
                  <div style="margin-bottom: 15px"> 完成-开始：以下任务完成后，当前任务才能开始 </div>
                  <div class="content" style="max-height: 200px; overflow-y: auto">
                    <div v-for="(item, index) in preTaskForm.preTaskList.filter(
                      (item) => item.relaStatus === '0')" :key="index" class="item"
                      style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; ">
                      <span style="color: #8daeed">
                        <span style="margin-right: 10px">{{ getWBSCode(item, 1) }}</span>
                        {{ item.preTaskName || item.taskName }}</span>
                      <span>
                        <i v-if="showType !== 'check'" class="el-icon-close" style="color: red; cursor: pointer"
                          @click="delPreTask(item, index)"></i>
                      </span>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <el-row v-show="!preTaskForm.preTaskList[0]" :gutter="60">
                <el-col :span="24">
                  <div style="text-align: center">
                    <img :src="zanwu" alt="" style="width:100px;height:100px" />
                    <p style="font-size:14px;color:#000;margin-top:10px"> 暂无数据 </p>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-transiton>
      </div>
      <!-- 紧后任务 编辑和详情的时候有-->
      <div v-show="showType !== 'add'" class="rearTask" style="min-height:300px">
        <div class="task-header" @click="() => afterTaskTrans = !afterTaskTrans">
          <h4>紧后任务</h4>
          <i :class="afterTaskTrans ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            style="font-weight: bold;margin-left:auto;"></i>
        </div>

        <el-collapse-transiton>
          <div v-show="afterTaskTrans">
            <el-form ref="afterTaskForm" :inline="true" :model="afterTaskForm" :rules="afterTaskFormRules"
              class="demo-form-inline baseForm" label-position="top" :disabled="showType === 'check'">
              <el-row v-show="afterTaskForm.afterTaskList.filter((item) => item.relaStatus === '1')[0]
                " :gutter="60" style="margin-bottom: 15px">
                <el-col :span="18">
                  <div>开始-开始：当前任务开始后，以下任务才能开始</div>
                  <div class="content" style="max-height: 200px; overflow-y: auto">
                    <div v-for="(item, index) in afterTaskForm.afterTaskList.filter(
                      (item) => item.relaStatus === '1'
                    )" :key="index" class="item"
                      style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; ">
                      <span style="color: #8daeed">
                        <span style="margin-right: 10px">{{
                          getWBSCode(item, 2)
                        }}</span>
                        {{ item.taskName }}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <el-row v-show="afterTaskForm.afterTaskList.filter(
                (item) => item.relaStatus === '0'
              )[0]
                " :gutter="60">
                <el-col :span="18">
                  <div style="margin-bottom: 15px">
                    完成-开始：当前任务结束后，以下任务才能开始
                  </div>
                  <div class="content" style="max-height: 200px; overflow-y: auto">
                    <div v-for="(item, index) in afterTaskForm.afterTaskList.filter(
                      (item) => item.relaStatus === '0'
                    )" :key="index" class="item"
                      style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; ">
                      <span style="color: #8daeed">
                        <span style="margin-right: 10px">{{
                          getWBSCode(item, 2)
                        }}</span>
                        {{ item.taskName }}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <el-row v-show="!afterTaskForm.afterTaskList[0]" :gutter="60">
                <el-col :span="24">
                  <div style="text-align: center">
                    <img :src="zanwu" alt="" style="width:100px;height:100px" />
                    <p style="font-size:14px;color:#000;margin-top:10px">
                      暂无数据
                    </p>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-transiton>
      </div>
      <!-- 评论区 详情才有-->
      <div v-if="showType === 'check'" class="operationInfo">
        <el-tabs v-model="activeName" @tab-click="tabClick">
          <el-tab-pane label="评论区" name="comment">
            <el-row :gutter="60">
              <el-col :span="18">
                <div class="comment">
                  <el-input v-model="discussContent" maxlength="100" show-word-limit type="textarea" :rows="4"
                    placeholder="增加评论/处理意见">
                  </el-input>
                  <div style="margin-top: 15px; text-align: right">
                    <el-button size="small" type="primary" :disabled="!discussContent" @click="addComment">
                      发表评论
                    </el-button>
                  </div>
                </div>
                <div class="list" style="max-height: 500px; overflow-y: auto">
                  <div v-for="(item, index) in commentList" :key="index" class="item"
                    style="padding: 10px; border-bottom: 1px solid #eee">
                    <div style=" color: #8091a5; font-size: 14px; margin-bottom: 5px; ">
                      {{ item.createTime }} {{ item.createUserName }} 新增
                    </div>
                    <div>{{ item.discussContent }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="修改记录" name="updateLog">
            <el-row :gutter="60">
              <el-col :span="24">
                <el-table :data="updateLogList" border max-height="500px" style="width: 100%">
                  <el-table-column show-overflow-tooltip align="center" prop="taskName" label="任务名称">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="startDate" label="任务开始时间">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="endDate" label="任务结束时间">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="taskTypeName" label="任务类型">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="taskUserName" label="责任人">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="operUserName" label="修改人">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="operDate" label="修改时间" width="175">
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="进度反馈" name="progressFeedback">
            <div style="max-height: 500px; overflow-y: auto">
              <div v-for="(item, index) in progressFeedBackList" :key="index" class="item"
                style="padding: 10px; border-bottom: 1px solid #eee">
                <div style="color: #8091a5; margin-bottom: 5px">
                  {{ item.createTime }} {{ item.createUserName }} 新增进度反馈
                </div>
                <div style="font-size: 14px">
                  <div>进度：{{ item.taskProgress }}%</div>
                  <div v-if="item.remark" style="padding: 5px 0">
                    备注:{{ item.remark }}
                  </div>
                  <div v-if="item.fileList.length">
                    <span>附件：</span>
                    <div style="display: inline-block; vertical-align: top">
                      <el-link v-for="(items, index) in item.fileList" :key="index" type="primary" style="display: block"
                        @click="dataPreview(items)">
                        {{ items.realName }}
                      </el-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 提交取消 只有添加和编辑的时候有-->
    <div v-if="showType !== 'check'" class="btns" :class="{ 'btns--add': showType === 'add' }">
      <el-button style="width: 95px" size="small" type="primary" :loading="submitLoading" @click="submit"> 提交 </el-button>
      <el-button style="width: 95px" size="small" @click="cancel"> 取消 </el-button>
    </div>
    <!-- 取消 只有详情的时候有 -->
    <div v-if="showType == 'check'" class="btns" :class="{ 'btns--add': showType === 'add' }">
      <el-button style="width: 95px" size="small" type="danger" @click="editForm"> 编辑 </el-button>
      <el-button style="width: 95px" size="small" type="primary" @click="cancel"> 返回 </el-button>
    </div>

    <el-dialog v-dialogDrag class="taskLabel" title="添加专业" :visible.sync="isShowTaskLabel" width="600px" top="17vh"
      :close-on-click-modal="false" :close-on-press-escape="false" @close="taskLabelClose">
      <div class="content">
        <el-form ref="form1" :inline="true" :model="taskLabelForm" :rules="taskLabelFormRules" label-position="top"
          size="small" @submit.native.prevent>
          <el-form-item label="专业名称" prop="taskLabelName" style="width: 100%; display: inline-block; margin-right: 0px">
            <el-input v-model="taskLabelForm.taskLabelName" maxlength="10"></el-input>
          </el-form-item>
        </el-form>
        <div class="taskLabelList">
          <div v-for="(item, index) in showTaskLabelList" :key="index" class="item" @click="toggleTaskLabel(item)">
            <span style="color: #538be6; width: 180px">{{
              item.labelName
            }}</span>
            <el-tag style=" border-radius: 50%; height: 30px; width: 30px; border: none; " :color="item.labelColor">
            </el-tag>
            <span style="width: 60px">
              <i v-show="baseForm.taskLabelList.some(
                (Item) => Item.labelId === item.labelId
              )
                " class="el-icon-check"></i>
            </span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag class="preTask" title="紧前任务" :visible.sync="isShowPreTaskBox" width="30%" append-to-body
      top="17vh" :close-on-click-modal="false" :close-on-press-escape="false" @close="preTaskClose">
      <div class="content">
        <div class="top">
          <span>选择紧前任务链接关系</span>
          <div>
            <el-radio v-model="preTaskRadio" label="1">
              开始-开始（所关联紧前任务开始后，当前任务才能开始）
            </el-radio>
            <el-radio v-model="preTaskRadio" label="0">
              完成-开始（所关联紧前任务完成后，当前任务才能开始）
            </el-radio>
          </div>
        </div>
        <div class="bottom">
          <span>选择紧前任务</span>
          <div class="tree">
            <el-input v-model="preTaskFilterText" size="small" style="width: 50%; margin-bottom: 10px"
              placeholder="输入关键字进行过滤" clearable>
            </el-input>
            <div class="treeWarp">
              <el-tree ref="preTaskTree" check-strictly default-expand-all :filter-node-method="preTaskFilterNode"
                :data="treeTask" node-key="taskId" :props="defaultProps" show-checkbox style="background: #f6f9fe"
                @check="handlePreTaskCheckChange">
                <span slot-scope="{ node, data }" class="custom-tree-node">
                  <span><span style="margin-right: 10px">{{
                    getWBSCode(data, 2)
                  }}</span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="preTaskClose">取 消</el-button>
        <el-button type="primary" size="small" @click="addPreTask">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag class="progressFeedBack" title="进度反馈" :visible.sync="isShowProgressFeedBackBox" width="30%"
      top="17vh" :close-on-click-modal="false" :close-on-press-escape="false" @close="progressFeedBackClose">
      <div class="content">
        <el-form ref="taskProgressform" :model="progressFeedForm" label-position="top" :rules="taskProgressrules"
          @submit.native.prevent>
          <el-form-item label="进度" prop="taskProgress">
            <el-input v-model.number="progressFeedForm.taskProgress" style="width: 300px" maxlength="3" show-word-limit>
            </el-input>
            %
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="progressFeedForm.remark" maxlength="100" show-word-limit type="textarea" :rows="4"
              placeholder="增加评论/处理意见">
            </el-input>
          </el-form-item>
          <el-form-item label="上传附件">
            <el-upload :disabled="disabledone2" class="dataUpload" :action="action" :limit="5" :on-success="dataOnSuccess"
              :on-remove="dataOnRemove" :on-preview="dataPreview" :before-upload="dataprogress2" :headers="headers"
              :file-list="progressFeedForm.fileList">
              <el-button :disabled="disabledone2" size="small" type="primary" plain icon="el-icon-upload2">
                上传文件
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="progressFeedBackClose">取 消</el-button>
        <el-button type="primary" :disabled="!progressFeedForm.taskProgress" size="small" :loading="taskProgressLoading"
          @click="addProgressFeedBack('taskProgressform')">确 定</el-button>
      </span>
    </el-dialog>
    <addPerson ref="addPerson" type="external" :triggerUpdatePersonList="triggerUpdatePersonList" :chargeUserList='chargeUserList'></addPerson>
  </div>
</template>

<script>
import request from "@/commonService/progress-service";
import proBackupsRequest from "@/commonService/downloadFile-service.js";
import elTreeSelect from "@/commonComponents/elTreeSelect";
import { uploadDataUrl, getToken, downloadFile } from "@/commonUtils";
import { mapState } from "vuex";
import globalParams from '@/commonUtils/globalParams'
import addPerson from "./addPerson/addPerson.vue"
import buildPlan from "@/xgzdService/buildPlan-service"
import quaService from "@/xgzdService/quaMange-service"
export default {
  components: { elTreeSelect, addPerson },
  props: {
    showType: {
      type: String,
      required: true
    }, // check是详情 add是添加  edit是编辑
    task: {
      type: String,
      required: true
    },
    placeType: {
      type: Number,
      required: true
    }
  },
  data() {
    const standardSchedules = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback();
      } else if (!/^[+]?\d+(\.\d)?$/.test(value)) {
        callback(new Error("必须输入正整数或者保留一位小数"));
      } else {
        callback();
      }
    };
    const taskProgresss = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback();
      } else if (/^(-[1-9][0-9]*)$/.test(value)) {
        callback(new Error("进度不能为负数"));
      } else if (value > 100) {
        callback(new Error("进度必须小于100%"));
      } else {
        callback();
      }
    };
    return {
      zanwu: require("@/commonAssets/暂无数据.png"),
      treeTask: [],
      taskGuideTrans: true,
      preTaskTrans: true,
      afterTaskTrans: true,
      showTypeRefresh: 0,
      isShowTaskLabel: false,
      isShowPreTaskBox: false,
      isShowProgressFeedBackBox: false,
      preTaskRadio: "0",
      coreTaskList: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      preTaskFilterText: "",
      preTaskChecks: [],
      defaultProps: {
        children: "childList",
        label: "taskName"
      },
      activeName: "comment",
      discussContent: "",
      commentList: [], // 所有评论
      updateLogList: [], // 修改记录
      progressFeedBackList: [], // 反馈记录
      loading: false,
      loadingTxt: "",
      submitLoading: false,
      action: "",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      userInfo: "",
      chargeUserList: [], // 所有人员
      taskType: [], // 任务类型
      taskLabelList: [], // 所有专业
      showTaskLabelList: [], // 过滤的专业
      baseForm: {
        prjId: "",
        parentId: "",
        taskName: "", // 任务名称
        isMilestone: 0,
        startDate: "", // 任务开始时间
        endDate: "", // 任务结束时间
        schedule: "", // 工期
        realEndDate: "", // 实际完成时间
        standardSchedule: "", // 标准工期
        taskType: {}, // 任务类型
        taskUserList: [], // 责任人
        taskLabelList: [], // 专业
        // guide: "", //任务指引
        fileList: [], // 附件列表
        taskUserName: "",
        prjStageChildPlanGroup: {
          prjStageChildPlanGroupID: "",
          prjStageChildPlanGroupName: ""
        }, // 子项分组管理
        guideList: [],
        flowDefinitionIdList: [],// 关联流程
        operationCode: "",//工序编号
        position: "",//所属位置
        specIds: [],
        spec: "",
        coreTask: 0
      },
      preTaskForm: {
        preTaskList: [] // 紧前任务
      },
      afterTaskForm: {
        afterTaskList: [] // 紧后任务
      },
      taskLabelForm: {
        taskLabelName: "",
        taskLabelColour: "#63b4f3"
      },
      progressFeedForm: {
        taskProgress: "",
        remark: "",
        fileList: []
      },
      baseFormRules: {
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        startDate: [{ required: true, message: "请选择任务开始时间", trigger: "change" }],
        endDate: [{ required: true, message: "请选择任务结束时间", trigger: "change" }],
        standardSchedule: [{ trigger: "blur", validator: standardSchedules }],
        taskUserList: [{ required: true, message: "请选择责任人", trigger: "change" }],
        taskLabelList: [{ required: true, message: "请选择专业", trigger: "change" }]
      },
      preTaskFormRules: {},
      afterTaskFormRules: {},
      taskLabelFormRules: {
        taskLabelName: [
          {
            required: true,
            message: "请输入专业名称",
            trigger: "blur"
          }
        ]
      },
      colors: [
        "#63b4f3",
        "#a457b3",
        "#e9726e",
        "#fbb165",
        "#abd780",
        "#a6a6a6"
      ],
      taskProgressrules: {
        taskProgress: [
          {
            type: "number",
            message: "进度必须为数字值"
          },
          {
            trigger: "blur",
            validator: taskProgresss
          }
        ]
      },
      submitStatus: "",
      taskData: {},
      taskId: "", // 提交成功后返回得id 用于跳转详情页面
      queryTaskId: "",
      errorInfo: {},
      type: "",
      setParentDisabledArr: new Set(),
      startDatePickerOptions: {},
      startDateKey: 0,
      endDatePickerOptions: {},
      endDateKey: 0,
      disabledone: false,
      disabledone2: false,
      taskProgressLoading: false,

      taskTypeTreeData: [],
      taskTypeTreeProps: {
        parent: "pid", // 父级唯一标识
        value: "id", // 唯一标识
        label: "cnName", // 专业显示
        children: "childNode" // 子级
      },
      checkType: "", // check是编辑 !check是添加
      childItemGroupList: [],

      taskGuideVisible: false,
      taskGuideForm: {
        guide: "",
        fileKeys: []
      },
      guideList: [],
      taskGuideRules: {
      },
      enableBindToFlow: true,
      specList: [],
      processList: [],
      roleList: [],
      curTaskUserList: [],
      childPlanName: "",
      guideActive: null,
      processOptions: {
        emitPath: false,
        label: "flowDefinitionName",
        value: "flowDefinitionId",
        children: "flowDefinitionList",
        multiple: true
      },
      selectSetData: [],
      fileList:[]
    };
  },
  created() {
    const type = "";
    this.queryTaskId = this.task;
    this.checkType = this.showType;
    if (type) {
      this.baseForm.isMilestone = 1;
    }
    this.setRouteName(this.showType, type);
    if (this.showType !== "add") {
      this.loadingTxt = "数据加载中...";
      this.loading = true;
      this.queryDetail();
    }
    this.getAllDic();
    this.action = uploadDataUrl();
    this.enableBindToFlow = globalParams.getFn("task.detail.bindToFlow", null, true);
  },

  methods: {
    clearUser(){
      this.chargeUserList=[]
      this.userInfo=""
    },
    editForm() {
        this.$router.push({
          name: "editTaskDetail",
          query: {
            showType: 'edit',
            task:this.$route.query.task || "0",
            conPlanId: this.$route.query.conPlanId 
          }
        });

    },
    managerBtn() {
      this.$refs.addPerson.updateShowType("external");
      this.$refs.addPerson.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addPerson.reset();
      });
    },
    /**
     * 确定添加数据后刷新列表
     */
    async triggerUpdatePersonList(checkUsers) {
      this.chargeUserList = checkUsers.map(item => {
        return {
          userName: item.name,
          userId: item.userId
        }
      });
      this.userInfo = checkUsers.map((item) => item.name)?.toString();
      this.$refs.addPerson.dialogVisible = false;
    },
    // 清空初始数据
    qinkong() {
      this.$refs.baseForm.resetFields();
      this.baseForm.prjId = "";
      this.baseForm.parentId = "";
      this.baseForm.taskName = "";
      this.baseForm.isMilestone = 0;
      this.baseForm.startDate = "";
      this.baseForm.endDate = "";
      this.baseForm.schedule = "";
      this.baseForm.realEndDate = "";
      this.baseForm.standardSchedule = "";
      this.baseForm.taskType = {};
      this.baseForm.taskUserList = [];
      this.baseForm.taskLabelList = [];
      this.baseForm.fileList = [];
      this.baseForm.taskUserName = "";
      this.baseForm.prjStageChildPlanGroup.prjStageChildPlanGroupID = "";
      this.baseForm.prjStageChildPlanGroup.prjStageChildPlanGroupName = "";
      this.baseForm.guideList = []; // 任务指引列表数据 传后台
      this.baseForm.specIds = []; // 专业
      this.baseForm.roleIds = []; // 责任岗位
      this.baseForm.coreTask = 0
      this.chargeUserList = []; // 责任人
      this.userInfo = "";
      this.baseForm.flowDefinitionIdList = []; // 关联流程下拉数据
      this.baseForm.operationCode = "";
      this.baseForm.position = "";
      this.taskGuideForm.guide = ""; // 任务指引输入框
      this.guideList = []; // 任务指引列表数据 保存展示
      this.taskGuideForm.fileKeys = []; // 任务指引文件
      this.preTaskForm.preTaskList = []; // 紧前任务
      this.afterTaskForm.afterTaskList = []; // 紧前任务
      this.fileList = []; 

    },
    // 任务指引 上移
    up(index) {
      if (index === 0) {
        return;
      }
      // 在上一项插入该项
      this.guideList.splice(index - 1, 0, this.guideList[index]);
      // 删除后一项
      this.guideList.splice(index + 1, 1);
      this.baseForm.guideList = JSON.parse(JSON.stringify(this.guideList));
    },
    // 任务指引 下移
    down(index) {
      if (index === this.guideList.length - 1) {
        return;
      }
      // 在下一项插入该项
      this.guideList.splice(index + 2, 0, this.guideList[index]);
      // 删除前一项
      this.guideList.splice(index, 1);
      this.baseForm.guideList = JSON.parse(JSON.stringify(this.guideList));
    },

    deWeightThree(arr) {
      const map = new Map();
      for (const item of arr) {
        if (!map.has(item.userId)) {
          map.set(item.userId, item);
        }
      }
      return [...map.values()];
    },

    guideSelectChange(index) {
      this.fileList = []
      if (index === "") {
        this.taskGuideForm = { guide: "", fileKeys: [] };
      } else {
        const data = JSON.parse(JSON.stringify(this.guideList[index]))
        data.fileKeys.forEach(item => {
          item.name = item.realName
        });
        this.taskGuideForm = data;
      }
    },

    taskTypeChange(data) {
      const { prjId } = this.prjInfo;
      request.queryAverageTaskTime({ prjId, taskTypeId: data.id }).then(res => {
        if (res.result === "0") this.baseForm.standardSchedule = res.data;
      });
    },
    removeGuide(index) {
      this.guideList.splice(index, 1);
      this.baseForm.guideList.splice(index, 1);
    },
    // 任务指引 保存和修改 确定按钮
    submitTaskGuideForm(type) {
      this.$refs["taskGuideForm"].validate(valid => {
        if (valid) {
          if (this.taskGuideForm.guide) {
            const guide = JSON.parse(JSON.stringify(this.taskGuideForm));
            if (type === "edit") {
              if (this.guideActive != null) {
                this.baseForm.guideList.splice(this.guideActive, 1, guide);
                this.guideList.splice(this.guideActive, 1, guide);
              } else {
                this.$message.warning("请先选择需要修改的指引！");
              }
            } else {
              this.baseForm.guideList.push(guide);
              this.guideList.push(guide);
              this.baseForm.fileList = this.baseForm.fileList.concat(this.fileList)
            }
            this.taskGuideForm.guide = "";
            this.taskGuideForm.fileKeys = [];
            this.guideActive = null;
          } else {
            this.$message.warning("请输入任务指引");
          }
        }
      });
    },
    // 任务指引 移除文件
    taskFileOnRemove(file, fileList) {
      const index = this.taskGuideForm.fileKeys.findIndex(item => item.fileKey === file.fileKey);
      this.taskGuideForm.fileKeys.splice(index, 1);
      this.baseForm.fileList.splice(index, 1);
    },
    // 任务指引 文件上传成功
    taskFileOnSuccess(response, file) {
      if (response.result === "0" && response.data) {
        response.data.name = response.data.realName;
        this.taskGuideForm.fileKeys.push(response.data);
        this.fileList.push(response.data);
      } else {
        this.$message.warning(response.message);
      }
    },
    getWBSCode(task, type) {
      const gantt = this.$store.state.projectMg.gantt;
      if (!gantt) {
        return "";
      }
      if (type === 1) {
        return gantt.getWBSCode(gantt.getTask(task.preTaskId || task.taskId));
      }
      return gantt.getWBSCode(gantt.getTask(task.taskId));
    },
    // 初始化时调用
    getAllDic() {
      request
        .queryTaskTypeTree()
        .then(res => {
          if (res.result === "0") {
            this.taskTypeTreeData = res.data.childNode || [];
          }
        })
        .catch(error => {
          this.$message.warning(error.message || "查询任务失败");
        });
      this.querySpecRoleList();
      this.querychildItemGroupList();
      if (this.placeType == 1) this.getSelectSet()
    },
    async getSelectSet() {
      const fileIds = this.$route.query.fileIds;
      const params = fileIds?.split(",")
      const { data } = await quaService.getSelectSetFolderTree(params);
      this.selectSetData = data[0]?.childList;
      console.log(this.selectSetData);
    },
    querySpecRoleList() {
      buildPlan.getSpecList().then(res => {
        if (res.result === "0") {
          this.specList = res.data;
        }
      });
    },
    querychildItemGroupList() {
      const { prjId } = this.prjInfo;
      request
        .queryChildItemGroupList(prjId)
        .then(res => {
          this.childItemGroupList = res.data;
        })
        .catch(e => {
          this.$message.warning(e.message || "查询子项分组失败");
        });
    },
    queryTaskLabelList() {
      request
        .queryTaskLabelList()
        .then(res => {
          if (res.result === "0") {
            this.taskLabelList = res.data;
            for (let i = 0; i < this.taskLabelList.length; i++) {
              this.taskLabelList[i].labelId = this.taskLabelList[i].labelID;
              // this.taskLabelList[i].labelName = this.taskLabelList[i].labelName
              this.taskLabelList[i].labelColour = this.taskLabelList[
                i
              ].labelColor;
            }
            this.showTaskLabelList = res.data;
            for (let k = 0; k < this.showTaskLabelList.length; k++) {
              this.showTaskLabelList[k].labelId = this.taskLabelList[k].labelID;
              // this.showTaskLabelList[k].labelName = this.taskLabelList[k].labelName
              this.showTaskLabelList[k].labelColour = this.taskLabelList[
                k
              ].labelColor;
            }
          }
        })
        .catch(e => {
          this.$message.warning(e.message || "查询专业失败");
        });
    },

    queryTreeTask() {
      const { prjId } = this.prjInfo;
      const isCore = 0;
      const { conPlanId } = this.$route.query;
      buildPlan.queryPlanList({ prjId, isCore, labelIds: [], enterpriseId: this.enterpriseId }, conPlanId).then(res => {
        if (res.result === "0") {
          if (res.data.list) {
            for (var t = 0; t < res.data.list.length; t++) {
              this.$set(res.data.list[t], "disabled", false);
              if (this.preTaskForm.preTaskList) {
                for (
                  var a = 0;
                  a < this.preTaskForm.preTaskList.length;
                  a++
                ) {
                  if (this.preTaskForm.preTaskList[a].preTaskId) {
                    // 已经有的
                    if (res.data.list[t].taskId === this.preTaskForm.preTaskList[a].preTaskId) {
                      this.$set(res.data.list[t], "disabled", true);
                    }
                  } else {
                    // 新添加的
                    if (res.data.list[t].taskId === this.preTaskForm.preTaskList[a].taskId) {
                      this.$set(res.data.list[t], "disabled", true);
                    }
                  }
                }
              }
              if (this.afterTaskForm.afterTaskList) {
                for (var v = 0; v < this.afterTaskForm.afterTaskList.length; v++) {
                  if (res.data.list[t].taskId === this.afterTaskForm.afterTaskList[v].taskId) {
                    this.$set(res.data.list[t], "disabled", true);
                  }
                }
              }
            }
            this.treeTask = res.data.list;
            this.filterArray(this.treeTask, this.queryTaskId);
          }
          // this.setDisabled(res.data)
        }
      })
        .catch(e => {
          this.$message.warning(e.message || "查询任务树失败");
        });
    },
    filterArray(data, taskId) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].taskId === taskId) {
          data[i].disabled = true;
          this.filterArray(data, data[i].parentId);
        }
      }
      // if(this.queryTaskId==='0'){
      this.treeTask = this.filterArray1(data, "0");
      // }else{
      //   this.filterArray2(this.treeTask,this.queryTaskId)
      // }
    },

    filterArray1(data, parentId) {
      console.log(data, parentId);
      const tree = [];
      let temp;
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId === parentId) {
          const obj = data[i];
          temp = this.filterArray1(data, data[i].taskId);
          if (temp.length > 0) {
            obj.childList = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },

    setRouteName(showType, type) {
      let routeName;
      // this.showType = showType;
      this.type = type;
      if (type) {
        routeName = type === "milestone" ? "新增里程碑" : "";
      } else {
        routeName =
          showType === "add"
            ? "任务"
            : showType === "edit"
              ? "编辑任务"
              : "任务详情";
      }
      this.$route.meta.routeName = "施工计划";
      this.$store.dispatch("updateNavArr");
    },

    taskLabelClose() {
      this.queryTaskLabelList();
      this.taskLabelForm.taskLabelName = "";
      this.taskLabelForm.taskLabelColour = "#63b4f3";
      this.isShowTaskLabel = false;
    },

    preTaskClose() {
      this.preTaskRadio = "0";
      this.preTaskFilterText = "";
      this.preTaskChecks = [];
      this.treeTask = [...this.treeTask];
      this.setParentDisabledArr = new Set();
      this.isShowPreTaskBox = false;
    },

    progressFeedBackClose() {
      this.progressFeedForm.taskProgress = "";
      this.progressFeedForm.remark = "";
      this.progressFeedForm.fileList = [];
      this.isShowProgressFeedBackBox = false;
    },

    handlePreTaskCheckChange(data, nodes) {
      this.preTaskChecks = nodes.checkedNodes;
    },

    toggleTaskLabel(Item) {
      const index = this.baseForm.taskLabelList.findIndex(
        item => item.labelId === Item.labelId
      );
      if (index > -1) {
        this.baseForm.taskLabelList.splice(index, 1);
      } else {
        if (this.baseForm.taskLabelList.length < 5) {
          this.baseForm.taskLabelList.push(Item);
        } else {
          this.$message({
            duration: 1000,
            message: "最多能选择5个专业",
            type: "warning",
            showClose: true
          });
        }
      }
    },

    addTaskLabel(formName) {
      if (this.baseForm.taskLabelList.length < 5) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            const labelName = this.taskLabelForm.taskLabelName;
            const labelColour = this.taskLabelForm.taskLabelColour;
            request
              .addTaskLabel({ labelName, labelColour })
              .then(res => {
                if (res.result === "0") {
                  this.baseForm.taskLabelList.push(res.data);
                  this.queryTaskLabelList();
                  this.taskLabelClose();
                }
              })
              .catch(e => {
                this.$message.warning(e.message || "添加失败");
              });
          } else {
            this.$message({
              duration: 1000,
              message: "请检查！有必填项未填写",
              type: "warning",
              showClose: true
            });
            return false;
          }
        });
      } else {
        this.$message({
          duration: 1000,
          message: "最多能选择5个专业",
          type: "warning",
          showClose: true
        });
      }
    },

    addPreTask() {
      this.preTaskChecks.forEach(item => {
        const { taskId, taskName } = item;
        const obj = {
          relaStatus: this.preTaskRadio,
          taskId,
          taskName
        };
        if (
          !this.preTaskForm.preTaskList.some(Item => Item.taskId === obj.taskId)
        ) {
          this.preTaskForm.preTaskList.push(obj);
          this.setParentDisabledArr.add(obj.taskId);
        }
      });
      // this.setDisabled(this.treeTask)
      this.preTaskClose();
    },

    addProgressFeedBack(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.taskProgressLoading = true;
          const taskId = this.queryTaskId;
          const { taskProgress, remark, fileList } = this.progressFeedForm;
          request
            .addProgressFeedBack({ taskProgress, remark, fileList, taskId })
            .then(res => {
              if (res.result === "0") {
                this.$message.success("添加成功");
                this.taskProgressLoading = false;
                this.taskData.taskProgress = this.progressFeedForm.taskProgress;
                this.queryProgressFeedBack();
                this.progressFeedBackClose();
              }
            })
            .catch(e => {
              this.taskProgressLoading = false;
              // this.taskData.taskProgress=''
              // this.$message.warning(e.message || "添加失败");
            });
        }
      });
    },

    //  编辑和查看详情时  查询任务的详情信息
    queryDetail() {
      const taskId = this.task;
      buildPlan.queryDetail(taskId)
        .then(res => {
          if (res.result === "0") {
            this.taskData = res.data;

            this.setArguments(res.data);
            this.loading = false;
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message.warning(error.message || "查询详情失败");
        });
    },
    // 添加和编辑时的 提交按钮
    submit() {
      const refFormArr = ["baseForm", "preTaskForm", "afterTaskForm"];
      const flagArr = [];
      refFormArr.forEach(item => {
        this.$refs[item].validate(valid => flagArr.push(valid));
      });
      if (flagArr.every(item => item === true)) {
        this.submitLoading = true;
        const data = this.getArguments();
        const requestType = this.showType === "add" ? "addPlan" : "editPlan";
        // const messageType = this.showType === "add" ? "添加" : "编辑";
        buildPlan[requestType](data)
          .then(res => {
            if (res.result === "0") {
              this.submitLoading = false;
              this.taskId = res.data;
              this.submitStatus = "succeed";
              this.$message({
                message: "提交成功",
                type: "success"
              });
              if (this.showType === "add") {
                this.$emit("dialogClose", true);
              } else {
                this.$router.push({ name: "buildTask", query: { conPlanId: this.$route.query.conPlanId } });
              }
            }
          })
          .catch(error => {
            this.errorInfo = error;
            this.submitLoading = false;
            this.submitStatus = "error";
            this.$message.warning(error.message || "添加失败");
          });
      } else {
        this.submitLoading = false;
        this.submitStatus = "error";
      }
    },

    // 添加和编辑时 设置一下 传给后台的数据
    getArguments() {
      const { baseForm, preTaskForm, afterTaskForm, queryTaskId } = this;
      const { prjId } = this.prjInfo;
      if (!this.baseForm.standardSchedule) {
        this.baseForm.standardSchedule = 0;
      }
      const {
        parentId,
        taskId,
        taskName, // 任务名称
        startDate, // 任务开始时间
        endDate, // 任务结束时间
        isMilestone, // 是否里程碑
        realEndDate,
        standardSchedule, // 标准工期
        taskType, // 任务类型
        taskUserList, // 责任人,
        taskLabelList, // 专业
        guideList, // 任务指引
        fileList, // 附件列表
        roleIds,
        flowDefinitionIdList, // 流程
        operationCode,
        position,
        coreTask,
        specIds,
        prjStageChildPlanGroup: {
          prjStageChildPlanGroupID,
          prjStageChildPlanGroupName
        }
      } = baseForm;
      const preTaskList = [];
      for (var i = 0; i < preTaskForm.preTaskList.length; i++) {
        // 已经有紧前任务
        if (preTaskForm.preTaskList[i].preTaskName) {
          var ddd = {
            taskId: preTaskForm.preTaskList[i].preTaskId,
            taskName: preTaskForm.preTaskList[i].preTaskName,
            relaStatus: preTaskForm.preTaskList[i].relaStatus
          };
        } else {
          // 没有紧前任务 或者 新添加时
          var ddd = {
            taskId: preTaskForm.preTaskList[i].taskId,
            taskName: preTaskForm.preTaskList[i].taskName,
            relaStatus: preTaskForm.preTaskList[i].relaStatus
          };
        }

        preTaskList.push(ddd);
      }
      const { afterTaskList } = afterTaskForm;
      const users = taskUserList.map(item => ({
        taskUserId: item.userId,
        taskUserName: item.name
      }));

      // 添加的时候
      const specList = specIds.map(item => {
        return {
          specId: item.id,
          specName: item.cnName
        }
      });
      return {
        prjId,
        parentId: this.showType === "add" ? queryTaskId : parentId,
        taskId,
        taskName, // 任务名称
        startDate, // 任务开始时间
        endDate, // 任务结束时间
        isMilestone,
        realEndDate,
        planSchedule: this.schedule,
        standardSchedule, // 标准工期
        taskType: taskType.id, // 任务类型
        taskTypeName: taskType.cnName, // 任务类型
        taskUserList: users, // 责任人,
        flowDefinitionIdList, // 流程
        taskLabelList, // 专业
        guideList: JSON.parse(JSON.stringify(guideList)), // 任务指引
        fileList, // 附件列表
        preTaskList, // 紧前任务
        afterTaskList, // 紧后任务
        prjStageChildPlanGroupID, // 子项分组GroupName
        prjStageChildPlanGroupName,
        enterpriseId: this.enterpriseId,
        position,
        operationCode,
        conPlanId: this.$route.query.conPlanId,
        specList,
        chargeUserList: this.chargeUserList,
        coreTask
      };
    },

    // 编辑和查看详情时 设置一下 任务的详情信息
    setArguments(resData) {
      const {
        prjId,
        parentId,
        taskId,
        taskName,
        startDate,
        endDate,
        isMilestone,
        realEndDate,
        standardSchedule,
        taskType,
        taskTypeName,
        taskUserList,
        taskLabelList,
        guideList,
        fileList,
        preTaskList,
        afterTaskList,
        taskUserName,
        coreTask,
        prjStageChildPlanGroupID,
        prjStageChildPlanGroupName,
        prjStageChildPlanGroupItems,
        flowDefinitionIdList,
        flowDefinitionNames,
        operationCode,
        position,
        specList,
        chargeUserList
      } = resData;
      this.baseForm.flowDefinitionIdList = flowDefinitionIdList;
      this.baseForm.flowDefinitionNames = flowDefinitionNames;
      this.baseForm.prjId = prjId;
      this.baseForm.parentId = parentId;
      this.baseForm.taskId = taskId;
      this.baseForm.taskName = taskName;
      this.baseForm.startDate = startDate;
      this.baseForm.endDate = endDate;
      this.baseForm.standardSchedule = standardSchedule;
      this.baseForm.isMilestone = isMilestone;
      this.baseForm.realEndDate = realEndDate;
      this.baseForm.taskUserName = taskUserName;

      this.childPlanName = prjStageChildPlanGroupItems;
      this.baseForm.position = position;
      this.baseForm.operationCode = operationCode;
      this.baseForm.specIds = specList.map(item => {
        return {
          cnName: item.specName,
          id: item.specId
        };
      })
      this.baseForm.spec = specList.map((item) => item.specName)?.toString()
      this.userInfo = chargeUserList.map((item) => item.userName)?.toString();
      this.chargeUserList = chargeUserList;
      this.baseForm.prjStageChildPlanGroup = {
        prjStageChildPlanGroupID,
        prjStageChildPlanGroupName
      };
      this.baseForm.taskType = {
        id: taskType,
        cnName: taskTypeName
      };
      this.baseForm.taskUserList = taskUserList.map(item => ({
        userId: item.taskUserId,
        name: item.taskUserName
      }));
      this.baseForm.taskLabelList = taskLabelList;
      this.baseForm.guideList = JSON.parse(JSON.stringify(guideList));
      this.guideList = JSON.parse(JSON.stringify(guideList));
      this.setFileList(fileList);
      this.baseForm.fileList = fileList;
      this.preTaskForm.preTaskList = preTaskList;
      this.afterTaskForm.afterTaskList = afterTaskList;
      this.baseForm.coreTask = coreTask
      // 设置初始折叠信息
      this.lengthAbsentAndSet(this.guideList, 'taskGuideTrans')
      this.lengthAbsentAndSet(this.preTaskForm.preTaskList, 'preTaskTrans')
      this.lengthAbsentAndSet(this.afterTaskForm.afterTaskList, 'afterTaskTrans')
    },

    lengthAbsentAndSet(arr, flagProp) {
      if (Array.isArray(arr) && arr.length > 0) {
        this[flagProp] = true
      } else {
        this[flagProp] = false
      }
    },
    setFileList(annexList) {
      annexList.forEach(item => {
        item.name = item.realName;
      });
    },

    cancel() {
      if (this.showType === "add") {
        this.$emit("dialogClose", false);
      } else {
        this.$router.push({ name: "buildTask", query: { conPlanId: this.$route.query.conPlanId,conPlanName:this.$route.query.conPlanName } });
      }
    },
    dataprogress() {
      this.disabledone = true;
    },
    dataprogress2() {
      this.disabledone2 = true;
    },
    dataOnSuccess(response, file, fileList) {
      if (response.result === "0" && response.data) {
        response.data.name = response.data.realName;
        if (this.isShowProgressFeedBackBox) {
          this.disabledone2 = false;
          this.progressFeedForm.fileList.push(response.data);
        } else {
          this.disabledone = false;
          this.baseForm.fileList.push(response.data);
        }
      }
    },

    dataOnRemove({ fileKey }) {
      const dataForm = this.isShowProgressFeedBackBox
        ? "progressFeedForm"
        : "baseForm";
      const index = this[dataForm].fileList.findIndex(
        item => item.fileKey === fileKey
      );
      if (index > -1) {
        this[dataForm].fileList.splice(index, 1);
      }
    },

    dataPreview({ filePath }) {
      if (this.showType === "check") {
        this.downFile(filePath);
      }
    },

    downFile(filePath) {
      const downzipurl = proBackupsRequest.downloadFile(filePath);
      downloadFile(downzipurl);
    },

    openPreTaskBox() {
      this.queryTreeTask();
      this.isShowPreTaskBox = true;
    },

    openProgressFeedBackBox() {
      var _this = this;
      try {
        _this.$refs["taskProgressform"].resetFields();
      } catch (e) {
        console.log();
      }
      _this.progressFeedForm.taskProgress = _this.taskData.taskProgress
      _this.isShowProgressFeedBackBox = true;
    },

    delPreTask(item) {
      this.removeByValue(this.preTaskForm.preTaskList, "id", item.id);
    },
    removeByValue(arr, attr, value) {
      // 数组，属性，属性值
      var index = 0;
      for (var i in arr) {
        if (arr[i][attr] === value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    preTaskFilterNode(value, data) {
      if (!value) return true;
      return data.taskName.indexOf(value) !== -1;
    },

    addComment() {
      const taskId = this.queryTaskId;
      const discussContent = this.discussContent;
      request
        .addComment({ taskId, discussContent })
        .then(res => {
          if (res.result === "0") {
            this.queryCommentList();
            this.discussContent = "";
          }
        })
        .catch(e => {
          this.$message.warning(e.message || "添加评论失败");
        });
    },

    tabClick(tab, event) {
      if (tab.name === "comment") {
        this.queryCommentList();
      } else if (tab.name === "updateLog") {
        this.queryUpdateLog();
      } else {
        this.queryProgressFeedBack();
      }
    },

    queryCommentList() {
      request
        .queryComment(this.queryTaskId)
        .then(res => {
          if (res.result === "0") {
            this.commentList = res.data;
          }
        })
        .catch(e => {
          this.$message.warning(e.message || "查询评论列表失败");
        });
    },

    queryUpdateLog() {
      request
        .queryUpdateLog(this.queryTaskId)
        .then(res => {
          if (res.result === "0") {
            this.updateLogList = res.data;
          }
        })
        .catch(e => {
          this.$message.warning(e.message || "查询修改记录失败");
        });
    },

    queryProgressFeedBack() {
      request
        .queryProgressFeedBack(this.queryTaskId)
        .then(res => {
          if (res.result === "0") {
            this.progressFeedBackList = res.data;
          }
        })
        .catch(e => {
          this.$message.warning(e.message || "查询反馈记录失败");
        });
    },

    sumSchedule(date1, date2) {
      const sdate = new Date(date1);
      const now = new Date(date2);
      const days = now.getTime() - sdate.getTime() + 86400000;
      const day = Math.abs(parseInt(days / (1000 * 60 * 60 * 24)));
      return day || "";
    }
  },

  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    childItemGroupListFiltered() {
      return this.childItemGroupList.filter(item => item.State == 0);
    },
    schedule() {
      const startData = this.baseForm.startDate;
      const endData = this.baseForm.endDate;
      return this.sumSchedule(startData, endData);
    },
    isGuideEditShow() {
      if (this.guideActive === "" || this.guideActive === null) return false;
      return true;
    }
  },

  watch: {
    "baseForm.startDate"(newValue, oldValue) {
      this.endDateKey = new Date().getTime();
      if (!this.$refs.endDateRef) return null;
      if (newValue === null) {
        this.baseForm.startDate = "";
      }
      this.$refs.endDateRef.pickerOptions.disabledDate = time => {
        return (
          new Date(this.baseForm.startDate).getTime() > time.getTime() + 8.64e7
        );
      };
    },

    "baseForm.endDate"(newValue, oldValue) {
      this.startDateKey = new Date().getTime();
      if (!this.$refs.startDateRef) return null;
      if (newValue === null) {
        this.baseForm.endDate = "";
      }
      this.$refs.startDateRef.pickerOptions.disabledDate = time => {
        return time.getTime() > new Date(this.baseForm.endDate).getTime();
      };
    },
    "baseForm.prjStageChildPlanGroup.prjStageChildPlanGroupID"(
      newValue,
      oldValue
    ) {
      const data = this.childItemGroupList.filter(item => item.ID === newValue);
      if (data.length > 0) {
        this.baseForm.prjStageChildPlanGroup.prjStageChildPlanGroupName =
          data[0].GroupName;
      }
    },

    "taskLabelForm.taskLabelName"(newValue, oldValue) {
      if (newValue) {
        this.showTaskLabelList = this.taskLabelList.filter(item =>
          item.labelName.includes(newValue)
        );
      } else {
        this.showTaskLabelList = this.taskLabelList;
      }
    },

    preTaskFilterText(val) {
      this.$refs.preTaskTree.filter(val);
    },
    task() {
      const type = "";
      this.queryTaskId = this.task;
      this.checkType = this.showType;
      if (type) {
        this.baseForm.isMilestone = 1;
      }
      this.setRouteName(this.showType, type);
      if (this.showType !== "add") {
        this.loadingTxt = "数据加载中...";
        this.loading = true;
        this.queryDetail();
      }
      this.getAllDic();
      this.action = uploadDataUrl();
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("updateIsShowNav", false);
    next();
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch("updateIsShowNav", true);
    });
  }
};
</script>
<style lang="scss">
.baseInfo {
  .el-cascader__tags {
    top: 47%;
  }
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.el-card.closed {
  ::v-deep .el-card__body {
    height: 0px;
    min-height: 0px !important;
    padding: 0px;
  }
}
#addContainer {
  width: 100%;
  height: 100%;
  background-color: #eff1f6;

  /deep/ .el-card {
    margin-bottom: 15px;

    &__body {
      overflow: auto;
      min-height: 150px;
      .el-collapse-item__header{
        height:100%;
        .el-textarea__inner{
          border:none;
        }
      }
      .el-collapse-item__header.is-active {
        background-color: rgb(249, 250, 252);
      }
    }
  }

  .header-title {
    border-left: 4px solid #4777E7;
    padding-left: 5px;
  }

  .progressIng {
    width: 100%;
    height: 60px;
    background: #fff;
    border: 1px solid #eee;
    padding: 0 35px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .taskName {
      font-weight: bold;
    }

    .createDate {
      color: #8091a5;
      font-size: 14px;
      margin-right: 10px;
    }
  }

  .cardInfo {
    box-shadow: 3px 3px 5px #888888;

    .el-row {
      line-height: 36px;
    }

    .el-col {
      display: flex;
    }

    .dataUpload {
      // display none
    }

    .el-upload {
      display: block;
    }

    .grid-content {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
    }
  }

  .progressStatus {
    width: 100%;
    height: 50px;
    background: #fff;
    line-height: 50px;
    padding: 0 35px;
    box-sizing: border-box;
  }

  .formWarp {
    width: 100%;
    background-color: #eff1f6;
    // padding: 0 165px;
    box-sizing: border-box;
    padding-bottom: 70px;

    .el-collapse-item {
      .header-icon {
        margin-left: 10px;
        visibility: hidden;
      }

      &:hover {
        .header-icon {
          margin-left: 10px;
          visibility: visible;
        }
      }
    }
    .frontTask,
    .rearTask {
      padding: 10px 20px !important;
      min-height: 0px !important;
      h4 {
        font-weight: bold !important;
      }

      .task-header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 20px;
        gap: 10px;
        cursor: pointer
        padding: 10px 0px;
        border-bottom: 1px solid #eee;
      }

      position: relative;

    }
    .baseInfo, .data, .operationInfo, .frontTask, .rearTask {
      width: 100%;
      margin-bottom: 15px;
      background-color: #fff;
      padding: 15px 35px;
      box-sizing: border-box;

      .contentInfo {
        /deep/ .el-input__inner {
          border: none;
        }

        /deep/ .el-input-group__append, .el-input-group__prepend {
          border: none;
          background-color: white;
        }

        /deep/ .el-form--inline .el-form-item__label {
          color: #8091a5;
        }

        /deep/ .el-textarea__inner {
          resize: none;
          border: none;
        }

        /deep/ .el-upload-list__item .el-icon-close {
          display: none !important;
        }

        /deep/ .el-upload-list__item-status-label {
          display: none !important;
        }

        /deep/ .el-upload {
          display: none;
        }

        .el-form--inline .el-form-item {
          display: flex;
        }

        /deep/ .el-upload-list__item.is-success.focusing .el-icon-close-tip {
          display: none !important;
        }
      }

      /deep/ .el-icon-circle-close {
        color: #C0C4CC;
      }

      /deep/ .el-form {
        padding-left: 15px;

        .el-form-item {
          width: 100%;

          .el-upload-list__item.is-success .el-upload-list__item-status-label {
            display: block;
          }

          .el-upload-list__item:hover {
            .el-icon-upload-success {
              display: none;
            }

            .el-icon-close {
              display: block;
            }
          }

          .el-form-item__content {
            width: 100%;

            .el-select {
              width: 100%;
            }

            .el-input {
              width: 100%;

              .el-input__inner {
                width: 100%;
              }
            }

            .el-upload__tip, .el-upload-list {
              padding-left: 15px;
            }
          }
        }

        .el-form-item__label {
          padding: 0;
        }

        .clientCode {
          .el-form-item__label {
            color: #faad14;
          }

          .el-input__inner {
            border: none;
            background-color: #fff;
          }
        }

        .dataUpload1 {
          .el-form-item__content {
            display: inline-block;
            width: 90%;
          }
        }
      }
    }
  }

  .formWarp--add {
    padding-bottom: 2px;
  }

  .btns {
    width: 100%;
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    margin-left: -2px;
    position: absolute;
    bottom: -15px;
    z-index: 99;
    box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);
  }

  .btns--add {
    position: sticky;
    width: calc(100% + 31px);
    margin-left: -16px;
  }

  /deep/ .taskLabel {
    .el-dialog__header {
      background-color: #4d89f6;

      .el-dialog__title {
        color: #fff;
      }

      .el-icon-close {
        color: #fff;
      }
    }

    .el-dialog__body {
      padding: 10px;
      height: 420px;
      box-sizing: border-box;
      background-color: #f1f2f6;

      .content {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 5px;
        padding: 20px;
        box-sizing: border-box;

        .el-form {
          .el-form-item__label {
            padding: 0;
          }

          .el-form-item__content {
            display: flex;
            align-items: center;
          }
        }

        .colors {
          display: flex;
          align-items: center;

          .item {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            margin-right: 20px;
            cursor: pointer;
          }

          .borderClass {
            width: 42px;
            height: 42px;
          }
        }

        .taskLabelList {
          width: 100%;
          height: 275px;
          padding: 10px 0;
          box-sizing: border-box;
          overflow-y: auto;

          .item {
            padding: 5px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #eee;
            cursor: pointer;

            i {
              color: red;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  /deep/ .preTask {
    .el-dialog__header {
      background-color: #fff;

      .el-dialog__title {
        color: black;
      }

      .el-icon-close {
        color: black;
      }
    }

    .el-dialog__body {
      padding: 10px;
      height: 420px;
      box-sizing: border-box;
      background-color: #f1f2f6;

      .content {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 5px;
        padding: 20px;
        box-sizing: border-box;

        .top {
          width: 100%;
          height: 100px;

          > div {
            margin-top: 30px;
            padding-left: 20px;
            box-sizing: border-box;
          }
        }

        .bottom {
          width: 100%;
          height: calc(100% - 100px);

          .tree {
            margin-top: 10px;
            height: calc(100% - 29px);
            background: #f6f9fe;
            padding: 15px;
            box-sizing: border-box;
            border: 1px solid rgb(217, 230, 253);
            background: rgb(246, 249, 254);

            .treeWarp {
              overflow-y: auto;
              height: calc(100% - 47px);
              background: #f6f9fe;

              .el-tree {
                background: #f6f9fe;

                .el-tree-node {
                  padding-top: 5px;

                  .el-tree-node__content {
                    border-bottom: 1px solid #d9e0ea;
                    color: #538be6;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  /deep/ .progressFeedBack {
    .el-dialog__header {
      background-color: #fff;

      .el-dialog__title {
        color: black;
      }

      .el-icon-close {
        color: black;
      }
    }

    .el-dialog__body {
      padding: 10px;
      height: 420px;
      box-sizing: border-box;
      background-color: #fff;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;

      .content {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 5px;
        padding: 20px;
        box-sizing: border-box;
        overflow-y: auto;

        .el-form {
          .el-form-item {
            margin-bottom: 10px;

            .el-upload-list__item.is-success .el-upload-list__item-status-label {
              display: block;
            }

            .el-upload-list__item:hover {
              .el-icon-upload-success {
                display: none;
              }

              .el-icon-close {
                display: block;
              }
            }

            .el-form-item__label {
              padding: 0;
            }

            .el-form-item__content {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
  }

  .addupload {
    /deep/ .el-upload {
      text-align: initial;
    }
  }
}
.el-icon-circle-close{
  cursor:pointer;
  line-height:32px;
}
</style>
